(ns frontend.util
  (:require [common.util]))

(defn uuid-vals->str
  [m]
  (update-vals m (fn [v]
                   (if (uuid? v)
                     (str v)
                     v))))

(defn attribute-map->js-attributes
  "Converts a Clojure map of attributes to a JavaScript object for use with OpenTelemetry."
  [form]
  (-> form
      common.util/flatten-map
      uuid-vals->str
      (clj->js {:keyword-fn (fn [k]
                              (-> k
                                  symbol
                                  str))})))
